<template>
  <aside v-if="html" class="blog-tldr">
    <p class="blog-tldr__label">TL;DR</p>
    <div class="blog-tldr__body longform" v-html="html"></div>
  </aside>
</template>

<script>
export default {
  name: "BlogTldr",
  props: {
    html: {
      type: String,
      default: "",
    },
  },
};
</script>
